<template>
  <div class="section section-clients align-center">
    <div class="container">
      <div class="section__header">
        <h1 class="headline section__header__headline">{{ sectionClientsContent.title }}</h1>
        <span class="section__header__tagline">{{ sectionClientsContent.sub_title }}</span>
      </div>
      <img class="responsive-image" v-for="client in clients" :alt="client.name" :title="client.name" :src="client.logo_url" :width="client.bio" :key="client.id">
    </div>
  </div>
</template>

<script>
export default {
	name: "Clients",
	data() {
		return {
			clients: [],
			sectionClientsContent: {}
		};
	},
	mounted() {
		this.getAll();
	},
	methods: {
		getAll() {
			this.$http
				.get(this.$parent.$parent.$parent.apiURL + "/clients")
				.then(function(response) {
					this.clients = response.body;
				});
			this.$http
				.get(
					this.$parent.$parent.$parent.apiURL +
						"/textblocks?filter[name]=homepage-section-clients"
				)
				.then(function(response) {
					this.sectionClientsContent = response.body;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Clients.vue